$(function() {

  $('.jsAudioPlayBtn').on('click', function(){
    var audioTarget = $(this).next('.jsAudioSound').get(0);
    if($(this).hasClass('isPlaying')){
      $(this).removeClass('isPlaying');
      audioTarget.currentTime = 0;
      audioTarget.pause();
      $(this).children('span').text('再生');
    } else {
      $('.jsAudioPlayBtn').each(function(){
        if($(this).hasClass('isPlaying')) {
          var playingTarget = $(this).next('.jsAudioSound').get(0);
          playingTarget.currentTime = 0;
          playingTarget.pause();
          $(this).removeClass('isPlaying');
          $(this).children('span').text('再生');
        }
      });
      $(this).addClass('isPlaying');
      audioTarget.play();
      $(this).children('span').text('停止');
      audioTarget.onended = function() {
        $('.jsAudioPlayBtn').removeClass('isPlaying');
        $('.jsAudioPlayBtn').children('span').text('再生');
      }
    }
    return false;
  });

});